import { jwtDecode } from "jwt-decode";

export default function access() {
  const token = localStorage.getItem('token');
  const currentUser: any = token ? jwtDecode(token) : {};

  return {
    isAdmin: currentUser['claim.role'] === 'Admin',
  };
}
